<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.11
        <br />2019
      </span>
      <span class="tiel">美菜网盛典，各大牌今日竟然因美菜节同框了</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        前几日，发生了一件令很多人感到惊奇的一件事，那就是能看到很多大牌竟然罕见同框，究竟是怎么回事呢？
        <br />
        <br />对于各大牌，“太太乐”和“家乐”，“海天”醋和“水塔”醋，就连“康师傅”和“统一”、“金龙鱼”和“福临门”也在今天一团和气。彷佛一夜之间，如有神助，化解了他们之间的“恩恩怨怨”。不仅如此，大牌们更是异口同声，不约而同地喊出“美在110，你我无忧购”。
        <br />
        <br />原来，今天是餐饮行业一年一度的“1.10美菜节”，该节日是由生鲜领域独角兽企业美菜网自创立之年就为餐饮人隆重打造的盛典。四年多来，“1.10美菜节”已然成了餐饮行业的“双十一”盛典。作为中国餐饮供应链杰出服务商，美菜网在推动餐饮供应链发展的路上一直奋力前行。与往年的“1.10美菜节”不同，今年的美菜节更为抢眼。
        <br />
        <br />
      </div>

      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

      <p align="center">
        <img src="@/assets/images/new-img/b010_1.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">1.10美菜节</div>
      <div class="title-bold">
        <span></span>大牌云集“1.10美菜节”，开启110餐饮同盟
      </div>
      <div class="tet-js">
        据了解，1月10号当天，著名的饮料品牌可口可乐、康师傅、统一、蒙牛等，以及中盐、海天、亨氏、水塔、家乐、太太乐、金龙鱼、福临门等米面粮油调料著名品牌，在活动当天纷纷为餐饮盛典“1.10美菜节”聚力打call，助力餐饮人自己的节日，也助推中国餐饮市场更快更好地发展。
        <br />
        <br />自成立以来，美菜网以其独有的模式，通过自建仓储、物流、配送，一端链接田间地头，一端链接城市，就此打通了从地头到终端的农产品供应链，既缩短了农产品的流通环节，降低了商户供应链成本，又减少了供应链人力，实现了农产品从地头到餐桌的高速流通，把砍去中间环节挤出来的利润真正让利给了农民和数以千万计的餐厅。通过四年多的发展和沉淀，美菜业务已覆盖了全国220个城市，其模式为279万家商户带去便利的同时也极大地变革了行业，改变了餐饮供应的旧有习惯。
        <br />
        <br />四年多的发展和壮大，让美菜不断地为餐饮供应链赋能升级，如今的“1.10美菜节”也从当初的“独乐乐”变为大牌云集的“众乐乐”，四年的进化和蜕变，也让美菜的“1.10”变身为众品牌云集“美菜赋能的1.10”，此次大牌聚力，彻底点燃了一场餐饮界的狂欢盛典。
        <br />
        <br />
      </div>
      <div class="title-bold">
        <span></span>四大无忧为“1.10美菜节”保驾护航。
      </div>
      <div class="tet-js">
        2018年10月，美菜网slogan“买菜卖菜上美菜”一经发布很快便在餐饮界传播开来，其餐饮供应链的龙头地位可见一斑，但美菜网并不就此止步。随后的一个月，美菜网又正式发布了无忧体系战略，以“品质无忧、价格无忧、选择无忧、服务无忧”为主导，旨在为餐厅商户提供更安心的服务。
        <br />
        <br />在“1.10美菜节”前发布无忧体系，美菜网意图明显，创始人兼CEO刘传军在不久前的一次走访商户的活动中曾向媒体透露，“1.10美菜节属于餐饮供应链行业的独特节日，与双十一类似。一方面，中国餐饮行业的万亿级市场带来的采购需求让美菜有这样千载难逢的机会。美菜希望通过这样的大的活动，推动餐饮采购行业的规模化。另一方面，1.10美菜节期间，我们希望通过四位一体的‘无忧体系’，给商户带去‘品质无忧、价格无忧、选择无忧、服务无忧’更优质的客户体验。”
        <br />
        <br />据数据显示，2018年中国餐饮市场零售总额已超4万亿，在餐饮行业高速变革的时机，美菜网与八十家餐饮名牌一起共同助力餐饮供应链的升级，推动餐饮市场的更好发展，可谓适逢其时;同时，“无忧”战略也借此次“1.10美菜节”的启动，为今后美菜网在餐饮供应链继续深耕的发展上保驾护航。
        <br />
        <br />美菜节现在已经成为了很多人心目当中的餐饮界的双十一，通过这次活动，不仅为广大人民群众带来了优惠，省下了钱，而且美菜网通过无忧战略，也提升了服务质量，使得服务更加优质，让美菜网更加深入人心。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
